import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-time-scan-main-area",
	templateUrl: "./time-scan-main-area.component.html",
	styleUrls: ["./time-scan-main-area.component.css"],
})
export class TimeScanMainAreaComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() lstScans: any = [];

	/////////////////////////////////////////////////////////////////
}
